import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { updateLineItem } from "../../../store/actions";

const QuantityInput = ({ lineItem }) => {
  const dispatch = useDispatch();

  const incrementQuantity = () => {
    dispatch(updateLineItem({ id: lineItem.id, quantity: lineItem?.quantity + 1 }));
  };

  const decrementQuantity = () => {
    dispatch(updateLineItem({ id: lineItem.id, quantity: lineItem?.quantity - 1 }));
  };

  return (
    <div className="quantity">
      <div onClick={decrementQuantity} className="quantity__minus">
        -
      </div>
      <input
        type="number"
        className="quantity__input"
        value={lineItem?.quantity ? lineItem?.quantity : 0}
        readOnly
      />
      <div onClick={incrementQuantity} className="quantity__plus">
        +
      </div>
    </div>
  );
};

QuantityInput.propTypes = {
  lineItem: PropTypes.object.isRequired,
};
export default QuantityInput;
